<template lang="pug">
.container
  div(v-if="isFetching")
    progress.progress.is-small.is-primary(max="100")
  div(v-else)
    .content.is-medium(v-if="selectedCollectionId === null")
      p.has-text-centered.has-text-primary Please select a collection
    .content.is-medium(
      v-else-if="selectedCollectionId !== null && papers.length === 0"
    )
      p.has-text-centered.has-text-primary This collection has no record
    div(v-else)
      b-field
      .level
        .level-item
          b-field(grouped, group-multiline)
            b-checkbox(v-model="columnsVisible.title") Title
            b-checkbox(v-model="columnsVisible.authors") Authors
            b-checkbox(v-model="columnsVisible.publication") Publication
            b-checkbox(v-model="columnsVisible.year") Year
            b-checkbox(v-model="columnsVisible.website") Website
            b-checkbox(v-model="columnsVisible.citeNum") Cited by (number)
              // b-checkbox(v-model="columnsVisible.apa") APA
              // b-checkbox(v-model="columnsVisible.bibtex") BibTeX
      .level
        .level-item
          b-select(v-model="paperNumPerPage")
            option(value="10") 10 per page
            option(value="25") 25 per page
            option(value="50") 50 per page
            option(value="100") 100 per page
        .level-item
          b-switch(v-model="searchable") Search
    <br>
    b-table(
      v-if="selectedCollectionId !== null && papers.length !== 0",
      :data="processedPapers",
      style={ overflow: auto },
      paginated,
      :current-page.sync="currentPage",
      :per-page="paperNumPerPage",
      pagination-position="bottom",
      aria-next-label="Next page",
      aria-previous-label="Previous page",
      aria-page-label="Page",
      aria-current-label="Current page"
    )
      b-table-column(field="no", label="No.", v-slot="props", centered) {{ props.index + 1 + (currentPage - 1) * paperNumPerPage }}
      b-table-column(
        field="title",
        label="Title",
        v-slot="props",
        width="30%",
        sortable,
        :visible="columnsVisible.title",
        :searchable="searchable"
      ) 
        span(v-if="props.row.linkToCitation != null")
          | <b>
          a(:href="props.row.linkToCitation", target="_blank") {{ preprocessCell(props.row.title) }}
          | </b>
        span(v-else)
          b  {{ preprocessCell(props.row.title) }} 
      b-table-column(
        field="authors",
        label="Authors",
        v-slot="props",
        width="20%",
        sortable,
        :visible="columnsVisible.authors",
        :searchable="searchable"
      ) {{ preprocessCell(props.row.authors) }}
      b-table-column(
        field="publication",
        label="Publication",
        v-slot="props",
        sortable,
        :visible="columnsVisible.publication",
        :searchable="searchable"
      ) {{ preprocessCell(props.row.publication) }}
      b-table-column(
        field="year",
        label="Year",
        v-slot="props",
        sortable,
        :visible="columnsVisible.year",
        :searchable="searchable"
      ) {{ preprocessCell(props.row.year) }}
      b-table-column(
        field="website",
        label="Website",
        v-slot="props",
        sortable,
        :visible="columnsVisible.website",
        :searchable="searchable"
      )
        div(style={ 'word-break': 'break-all' }) {{ preprocessCell(props.row.website) }}
      b-table-column(
        field="citeNum",
        label="Cited by",
        v-slot="props",
        sortable,
        numeric,
        :visible="columnsVisible.citeNum",
        :searchable="searchable"
      ) {{ preprocessCell(props.row.citeNum) }}
      b-table-column(
        field="apa",
        label="Apa",
        v-slot="props",
        sortable,
        :visible="columnsVisible.apa"
      )
        b-button(
          v-if="props.row.apa != null",
          type="is-primary",
          @click="openMessageBox(props.row.apa)"
        ) APA
        span(v-else) -
      b-table-column(
        field="bibtex",
        label="BibTeX",
        v-slot="props",
        sortable,
        :visible="columnsVisible.bibtex"
      )
        b-button(
          v-if="props.row.bibtex != null",
          type="is-primary",
          @click="openMessageBox(props.row.bibtex)"
        ) BibTeX
        span(v-else) -
      b-table-column(field="", label="", v-slot="props")
        .level
          .level-item
            b-button(
              type="is-success",
              @click="() => { uiOpenEditPaperModal(props.row); }"
            ) Edit
</template>
<script>
import { mapState, mapMutations } from "vuex";

export default {
  data: () => ({
    columnsVisible: {
      title: true,
      authors: true,
      publication: true,
      year: true,
      website: true,
      citeNum: false,
      linkToCitation: false,
      apa: false,
      bibtex: false,
    },
    currentPage: 1,
    paperNumPerPage: 10,
    searchable: false,
  }),
  computed: {
    ...mapState("collection", {
      papers: (s) => s.rawPapers,
      selectedCollectionId: (s) => s.selectedCollectionId,
      isFetching: (s) => s.isFetchingPapers,
    }),
    processedPapers() {
      if (this.papers.length > 0) {
        const output = this.papers.map((x) => {
          const parseResult = parseInt(x.citeNum);
          let newCiteNum = null;
          if (!isNaN(parseResult)) {
            newCiteNum = parseResult;
          }
          return Object.assign({}, x, { citeNum: newCiteNum });
        });
        return output;
      } else {
        return [
          {
            title: "",
            authors: "",
            publication: "",
            year: "",
            website: "",
            cite: "",
          },
        ];
      }
    },
  },
  methods: {
    ...mapMutations("editPaper", {
      openEditPaperModal: "openModal",
    }),
    uiOpenEditPaperModal(row) {
      const input = Object.assign({}, row);
      this.openEditPaperModal(input);
    },
    preprocessCell(cellContent) {
      return cellContent ?? "-";
    },
  },
};
</script>